import theme from '../../shared/styles/themes/default.theme'

const styles = {
  container: (numberOfItems: number) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: '100%',
    [theme.breakpoints.down('md')]: {
      paddingBottom: numberOfItems >= 1 ? theme.spacing(10) : 'unset'
    }
  })
}

export default styles
